/**
 * Canonical outbound links for the marketing site.
 *
 * The dashboard (sign-up / sign-in) is a separate app on its own domain, so we
 * link out via absolute URLs sourced from env. These are `NEXT_PUBLIC_*` so they
 * are inlined at build time and usable from both server and client components.
 */

import { normalizeSiteUrl } from './seo-utils';

/** Public URL of the marketing site itself (used for metadata / canonical). */
export const siteUrl = normalizeSiteUrl(
  process.env.NEXT_PUBLIC_SITE_URL ?? process.env.NEXT_PUBLIC_APP_URL,
);

/** Dashboard base URL (the authenticated app). */
const dashboardBase = process.env.NEXT_PUBLIC_DASHBOARD_URL ?? 'https://app.kasbly.com';

/** Direct sign-up link — sends visitors straight into account creation. */
export const signUpUrl = `${dashboardBase.replace(/\/$/, '')}/sign-up`;

/** Direct sign-in link. */
export const signInUrl = `${dashboardBase.replace(/\/$/, '')}/sign-in`;

/** Documentation site (Starlight, served on its own subdomain). */
export const docsUrl = process.env.NEXT_PUBLIC_DOCS_URL ?? 'https://docs.kasbly.com';
